<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Weekly Room Rewards' : 'Deleted Weekly Room Rewards'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/weekly_room_rewards/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search by frame or medal..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="target_range"
                    solo
                    rounded
                    v-model="filter.target_range"
                    :items="targetRanges"
                    label="Target Range"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-target"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="weeklyRoomRewards.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Weekly Target</th>
                      <th class="text-left">Weekly Reward</th>
                      <th class="text-left">Frame</th>
                      <th class="text-left">Medal</th>
                      <th class="text-left">Reward Tier</th>
                      <th class="text-left">Created By</th>
                      <th class="text-start action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="weeklyRoomRewards.length != 0">
                    <tr v-for="(reward, i) in weeklyRoomRewards" :key="`reward${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="reward.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Reward is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-cancel</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Reward is Inactive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ formatNumber(reward.weekly_room_target) }}</td>
                      <td>{{ formatNumber(reward.weekly_reward) }}</td>
                      <td>{{ reward.frame || 'N/A' }}</td>
                      <td>{{ reward.medal || 'N/A' }}</td>
                      <td>
                        <v-chip
                          small
                          :color="getTierColor(reward.weekly_room_target)"
                          text-color="white"
                        >
                          {{ getRewardTier(reward.weekly_room_target) }}
                        </v-chip>
                      </td>
                      <td>{{ reward.creator ? reward.creator.name : 'N/A' }}</td>
                      <td style="min-width: 125px">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="error"
                                @click="Delete_this(reward.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this reward</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/weekly_room_rewards/${encryptIt(reward.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this reward</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(reward.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this reward</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_reward" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Weekly Room Reward deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_reward = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_reward" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Weekly Room Reward restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_reward = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "weeklyRoomRewardsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        target_range: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_reward: false,
      restore_reward: false,
      is_restored_reward: false,
      weeklyRoomRewards: [],
      statuses: [
        {
          id: 0,
          text: "Select Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      targetRanges: [
        {
          id: 0,
          text: "Select Target Range",
          value: "",
        },
        { id: "LOW", text: "Low (0-200)", value: "low" },
        { id: "MID", text: "Mid (201-500)", value: "mid" },
        { id: "HIGH", text: "High (501-1000)", value: "high" },
        { id: "PREMIUM", text: "Premium (1000+)", value: "premium" },
      ],
      isLoading: false,
      isExcelloading: false,
      excel_fields: {
        "Sr No": "sr_no",
        "Weekly Target": "weekly_room_target",
        "Weekly Reward": "weekly_reward",
        Frame: "frame",
        Medal: "medal",
        "Reward Tier": "reward_tier",
        "Is Active": "status",
      },
    };
  },
  watch: {
    page: "getData",
  },

  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        let response = await axios.get(
          `/weekly_room_rewards?${this.getQueryParams()}`
        );

        if (response.data.success) {
          this.weeklyRoomRewards = response.data.data;
          this.count = response.data.count;
          this.paginationLength = Math.ceil(this.count / 10);
        } else {
          this.$store.dispatch("snackBar", {
            color: "error",
            message: response.data.message || "Failed to load weekly room rewards",
          });
        }
      } catch (error) {
        console.error("Error fetching weekly room rewards:", error);
        this.$store.dispatch("snackBar", {
          color: "error",
          message: "Failed to load weekly room rewards",
        });
      } finally {
        this.isLoading = false;
      }
    },

    getQueryParams() {
      const params = new URLSearchParams();
      params.append("page", this.page);
      params.append("rowsPerPage", 10);

      if (this.filter.search_keyword) {
        params.append("search_keyword", this.filter.search_keyword);
      }
      if (this.filter.is_active !== "") {
        params.append("is_active", this.filter.is_active);
      }
      if (this.filter.target_range) {
        this.setTargetRangeParams(params);
      }
      if (this.isDeletePage()) {
        params.append("show_deleted", "1");
      }

      return params.toString();
    },

    setTargetRangeParams(params) {
      switch (this.filter.target_range) {
        case "low":
          params.append("max_target", "200");
          break;
        case "mid":
          params.append("min_target", "201");
          params.append("max_target", "500");
          break;
        case "high":
          params.append("min_target", "501");
          params.append("max_target", "1000");
          break;
        case "premium":
          params.append("min_target", "1001");
          break;
      }
    },

    async Delete_this(id) {
      try {
        let response = await axios.post(`/weekly_room_rewards/delete/${this.encryptIt(id)}`);

        if (response.data.success) {
          this.is_deleted_reward = true;
          this.getData();
        } else {
          this.$store.dispatch("snackBar", {
            color: "error",
            message: response.data.message || "Failed to delete reward",
          });
        }
      } catch (error) {
        console.error("Error deleting reward:", error);
        this.$store.dispatch("snackBar", {
          color: "error",
          message: "Failed to delete reward",
        });
      }
    },

    async Restore_this(id) {
      try {
        let response = await axios.post(`/weekly_room_rewards/restore/${id}`);

        if (response.data.success) {
          this.is_restored_reward = true;
          this.getData();
        } else {
          this.$store.dispatch("snackBar", {
            color: "error",
            message: response.data.message || "Failed to restore reward",
          });
        }
      } catch (error) {
        console.error("Error restoring reward:", error);
        this.$store.dispatch("snackBar", {
          color: "error",
          message: "Failed to restore reward",
        });
      }
    },

    async generateExcel() {
      this.isExcelloading = true;
      try {
        let response = await axios.get(
          `/weekly_room_rewards/excel?${this.getQueryParams()}`,
          { responseType: 'blob' }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'weekly_room_rewards.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$store.dispatch("snackBar", {
          color: "success",
          message: "Excel file downloaded successfully",
        });
      } catch (error) {
        console.error("Error generating excel:", error);
        this.$store.dispatch("snackBar", {
          color: "error",
          message: "Failed to generate excel file",
        });
      } finally {
        this.isExcelloading = false;
      }
    },

    formatNumber(value) {
      if (!value) return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getRewardTier(target) {
      const targetValue = parseInt(target) || 0;

      if (targetValue >= 2000) return 'Legendary';
      if (targetValue >= 1500) return 'Epic';
      if (targetValue >= 1000) return 'Diamond';
      if (targetValue >= 500) return 'Platinum';
      if (targetValue >= 200) return 'Gold';
      if (targetValue >= 100) return 'Silver';
      if (targetValue >= 50) return 'Bronze';
      return 'Starter';
    },

    getTierColor(target) {
      const tier = this.getRewardTier(target);
      const colorMap = {
        'Legendary': 'purple',
        'Epic': 'deep-purple',
        'Diamond': 'blue',
        'Platinum': 'cyan',
        'Gold': 'amber',
        'Silver': 'grey',
        'Bronze': 'brown',
        'Starter': 'green'
      };
      return colorMap[tier] || 'grey';
    },

    isDeletePage() {
      return this.$route.query.show_deleted === "true";
    },

  },
};
</script>

<style scoped>
.striped-table >>> tbody tr:nth-child(odd) {
  background-color: #f5f5f5;
}

.action_th {
  min-width: 125px !important;
}
</style>